import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

import { SyncFileRow } from "@components";

import { AttachedFilesType } from "@type/HRM/attached-files";
import { UploadFileType } from "@type/HRM/upload-file";

import { revertSyncData } from "@utils/documentDataConvert";
import {
  ATTACHED_FILES,
  AttachedFilesFormDataType,
  attachedFilesValidation,
} from "@validations/HRM/employee/attachedFiles";

interface DocumentsProps {
  createAttachedFile: (uploadedFile: UploadFileType) => void;
  removeAttachedFile: (uploadFile: UploadFileType) => void;
  attachedFiles: AttachedFilesType;
  isProfileDisabled: boolean;
}

export const Documents = ({
  createAttachedFile,
  removeAttachedFile,
  attachedFiles,
  isProfileDisabled,
}: DocumentsProps) => {
  const methods = useForm<AttachedFilesFormDataType>({
    resolver: yupResolver(attachedFilesValidation),
    values: revertSyncData(attachedFiles) as AttachedFilesType,
  });

  const {
    register,
    formState: { errors },
    control,
    setValue,
    // watch,
  } = methods;

  // const updateFile = (selectedFile: UploadFileType) => {
  //   createAttachedFile({
  //     ...selectedFile,
  //     documentName: watch(`documentName-${selectedFile.documentId}`),
  //     date: watch(`date-${selectedFile.documentId}`),
  //     remarks: watch(`remarks-${selectedFile.documentId}`),
  //     memorialNo: watch(`memorialNo-${selectedFile.documentId}`),
  //   });
  // };

  return (
    <form className="d-flex flex-column gap-10 pb-10">
      <SyncFileRow
        label="EMPLOYEE.ATTACHED_FILES.FORM.UPLOAD_PHOTO"
        name={ATTACHED_FILES.UPLOAD_PHOTO}
        control={control}
        setValue={setValue}
        register={register}
        error={errors}
        removeAction={removeAttachedFile}
        addAction={createAttachedFile}
        acceptImage
        disabled={isProfileDisabled}
      />
      <SyncFileRow
        label="EMPLOYEE.ATTACHED_FILES.FORM.UPLOAD_SEAL"
        name={ATTACHED_FILES.UPLOAD_SEAL}
        control={control}
        setValue={setValue}
        register={register}
        error={errors}
        removeAction={removeAttachedFile}
        addAction={createAttachedFile}
        acceptImage
        disabled={isProfileDisabled}
        // fileDetails={["documentName", "date", "remarks", "memorialNo"]}
        // updateSyncFile={(selectedFile) => updateFile(selectedFile)}
      />
      <SyncFileRow
        label="EMPLOYEE.ATTACHED_FILES.FORM.UPLOAD_SIGNATURE"
        name={ATTACHED_FILES.UPLOAD_SIGNATURE}
        control={control}
        setValue={setValue}
        register={register}
        error={errors}
        removeAction={removeAttachedFile}
        addAction={createAttachedFile}
        acceptImage
        disabled={isProfileDisabled}
      />
    </form>
  );
};
